export function activateTab(evt, tab) {
    if (!(evt.target instanceof Element))
        return;
    const tabEl = typeof tab === 'string' ? document.getElementById(tab) : tab;
    if (!tabEl)
        return;
    const btn = evt.target.closest('.btn-tab');
    if (!btn || !(btn instanceof HTMLElement))
        return;
    btn?.parentElement?.querySelectorAll('.btn-tab').forEach((otherBtn) => {
        otherBtn.classList.remove('active');
    });
    btn.classList.add('active');
    tabEl?.parentElement?.querySelectorAll('.tab').forEach((otherTab) => {
        otherTab.classList.add('hidden');
    });
    tabEl.classList.remove('hidden');
}
